import BaseScene from './BaseScene';
import ButtonSprite from '../components/ButtonSprite';
import translate from '../components/LanguageManager';

export default class Score extends BaseScene {

    private globalScores: any[] = []; 
    private userId: integer = 0;
    private userScore: integer = 0;
    private isTop = false;
    private container: any;

    constructor() {
        super({key: 'Score'});
    }

    public init() {
        super.init();
        this.globalScores = this.getBootloaderScene().AppData.globalScores;
        this.userId = this.getBootloaderScene().AppData.user.id;
        this.userScore = this.getBootloaderScene().AppData.totals.score;
        this.isTop = false;
    }

    public create() {
        super.create();

        // BG
        this.add.rectangle(this.width / 2, this.height / 2, 2000, 2000, parseInt('000000', 16)).setAlpha(0.7);
        
        // Panel
        const panel = this.add.image(0, 0,'game_panel_about').setScale(1.3, 1.45);

        // Back Button
        const backButton = new ButtonSprite(this, -10, 330, 'button_back', 2, () => this.backToMainMenu());

        // Score text
        const scoreText = this.add.text(90, -360, `${translate.key('Points')}:`)
            .setWordWrapWidth(320)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 20,
                color: '#696969',
            });

        // Container
        this.container = this.add.container(this.width / 2, -300).add([panel, backButton, scoreText]);

        // List
        this.globalScores.forEach((score: any, index: integer) => {

            let nameColor = '#08789c';

            if(this.userId == score.user_id) {
                this.isTop = true;
                nameColor = '#dd2808';
            }

            const nameText = this.add.text(-170, (index * 50) -340, score.name)
                .setStyle({ 
                    fontFamily: 'supersonic',
                    fontSize: 32,
                    color: nameColor,
                    align: 'right'
                });

            const scorePoints = this.add.text(90, (index * 50) -335, score.total_score)
                .setWordWrapWidth(320)
                .setStyle({ 
                    fontFamily: 'soupofjustice',
                    fontSize: 28,
                    color: '#696969',
                });

            this.container.add([nameText, scorePoints]);
        });


        // You score
        if(!this.isTop) {
            const scoreWhenNotTop = this.add.text(-20, 185, `... ${translate.key('score_text_1')} ` + this.userScore)
                .setOrigin(0.5)
                .setWordWrapWidth(320)
                .setStyle({ 
                    fontFamily: 'soupofjustice',
                    fontSize: 28,
                    color: '#3d3d3d',
                });
            this.container.add([scoreWhenNotTop]);
        }

        // Tween
        this.tweens.add({
            y: 460,
            targets: this.container,
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });
    }

    private backToMainMenu() {
        this.getBootloaderScene().stopScene('Score');
        this.scene.resume('MainMenu');
    }
}
